export interface FrequencyCounter {
  value: number;
  label: string;
  icon: string;
  highlight?: boolean;
  suffix?: string;
}

// ─── Datos reales alineados con saFrequenciesData ───
// Total: 11,301 frecuencias (87.00 – 200.00 MHz, step 0.01)
// Ocupadas: 34 | Reservadas: 10 | Bloqueadas: 10 | Libres: 11,247

export const TOTAL_FREQUENCIES = 11301;
export const FREQ_OCUPADAS = 34;
export const FREQ_RESERVADAS = 10;
export const FREQ_BLOQUEADAS = 10;
export const FREQ_LIBRES = TOTAL_FREQUENCIES - FREQ_OCUPADAS - FREQ_RESERVADAS - FREQ_BLOQUEADAS;
export const FREQ_DISPONIBLES = 11300; // disponible ≈ total en esta etapa

export const frequencyCounters: FrequencyCounter[] = [
  { value: FREQ_DISPONIBLES, label: "Frecuencias Disponibles", icon: "ri-radar-line", highlight: true },
  { value: FREQ_OCUPADAS, label: "Frecuencias Ocupadas", icon: "ri-check-double-line" },
  { value: FREQ_LIBRES, label: "Frecuencias Libres", icon: "ri-flashlight-line" },
  { value: FREQ_RESERVADAS, label: "Frecuencias Reservadas", icon: "ri-time-line" },
];

// ─── Versión compacta para banners (sin el total, solo las 3 categorías) ───
export const frequencyStatusCompact = [
  { value: FREQ_OCUPADAS, label: "Ocupadas", icon: "ri-radio-button-line", color: "text-red-500", bg: "bg-red-50", border: "border-red-200" },
  { value: FREQ_LIBRES, label: "Libres", icon: "ri-checkbox-circle-line", color: "text-emerald-500", bg: "bg-emerald-50", border: "border-emerald-200" },
  { value: FREQ_RESERVADAS, label: "Reservadas", icon: "ri-time-line", color: "text-amber-500", bg: "bg-amber-50", border: "border-amber-200" },
];